import { createSelector } from "reselect";
import { checkedLocationIdsSelector } from "../checked_location_ids_selector";

export const selectedLocationIdsSelector = createSelector(
  checkedLocationIdsSelector,
  checkedLocationIds => {
    if (checkedLocationIds.length) return checkedLocationIds;
  }
);
